import { render, staticRenderFns } from "./PriceConf.vue?vue&type=template&id=304906b1"
import script from "./PriceConf.vue?vue&type=script&lang=js"
export * from "./PriceConf.vue?vue&type=script&lang=js"
import style0 from "./PriceConf.vue?vue&type=style&index=0&id=304906b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports